<template>
    <div class="col-md-6">
        <div class="well">
            <h2>{{ getTranslation('lbl_settings') }}</h2>
            <form name="callSettings" @submit.prevent="saveSettings">
                <div class="form-group">
                    <label for="call_tries">{{ getTranslation('lbl_tries') }}</label>
                    <input
                            type="text"
                            id="call_tries"
                            class="form-control"
                            formControlName="call_tries"
                            v-model="tries">
                </div>
                <div class="form-group">
                    <label for="call_all_contacts">{{ getTranslation('lbl_v5_tries_period') }}</label>
                    <app-slider
                            min="1"
                            max="9"
                            step="1"
                            raising
                            :values="ticksVals"
                            v-model="triesPeriod" />
                </div>
                <div class="form-group">
                    <label for="call_all_contacts">{{ getTranslation('lbl_v5_call_all_contacts') }}</label>
                    <app-switch
                            id="call_all_contacts"
                            :autoSave="false"
                            :isInList="false"
                            identification="callAll"
                            v-model="callAll"
                    />
                </div>
                <hr/>
                <button
                        @click.prevent="saveSettings"
                        class="btn btn-primary"
                        type="submit"
                >
                    {{ getTranslation('button_label_submit') }}
                </button>
            </form>

        </div>
    </div>
</template>

<script>
    import Switch from "../../../public/components/Switch.vue";
    import CustomSlider from "vue-custom-range-slider";
    export default {
        props: ['client', ],
        components: {
            'app-switch': Switch,
            'app-slider': CustomSlider,
        },
        data: function() {
            return {
                callAll: false,
                tries: null,
                triesPeriod: null,
                ticksVals: [
                    {
                        label: '5s',
                        value: '5',
                    },
                    {
                        label: '15s',
                        value: '15',
                    },
                    {
                        label: '30s',
                        value: '30',
                    },
                    {
                        label: '1m',
                        value: '60',
                    },
                    {
                        label: '2m',
                        value: '120',
                    },
                    {
                        label: '3m',
                        value: '180',
                    },
                    {
                        label: '4m',
                        value: '240',
                    },
                    {
                        label: '5m',
                        value: '300',
                    },
                    {
                        label: '10m',
                        value: '600',
                    },
                    {
                        label: '15m',
                        value: '900',
                    },
                ],
            }
        },
        sockets: {
            clientData: function(client) {
                if(!client || typeof client === "undefined") { return; }
                this.callAll = client.callAll;
                this.triesPeriod = '' + client.triesPeriod;
                this.tries = client.tries;
            },
        },
        created: function () {
            this.$socket.emit('getClientPerUser');
        },
        computed: {
            translations: function () {
                let storeTranslations = this.$store.getters.getTranslations;
                return storeTranslations;
            },
        },
        methods: {
            getTranslation: function(key) {
                if (!this.translations[key]) {
                    let defTrans  = this.$store.getters.getDefaultTranslations;
                    this.translations[key] = (defTrans[key]) ? defTrans[key] : key;
                }
                return this.translations[key];
            },
            saveSettings() {
                const callSettings = {
                    _id: this.client._id,
                    tries: this.tries,
                    triesPeriod: this.triesPeriod,
                    callAll: this.callAll,
                };
                this.$socket.emit('callSettingsUpdate', callSettings);
                this.$http.post('refresh').then(res=>{
                    console.log('REFRESH');
                });
            },
        },
    }
</script>


// WEBPACK FOOTER //
// call_settings.vue?080cdb0d